export const processNan = (val) => (isNaN(val) ? 0 : val)

export const formattedNumber = (value) => {
  return Number(value).toLocaleString('en-US')
}
